import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import Modal from '../layout/Modal';
import SignInButton from '../layout/SignInButton';

export type SignInModalProps = {
    isOpen: boolean;
    onClose: () => void;
    callbackUrl?: string;
};

export default function SignInModal({ isOpen, onClose, callbackUrl }: SignInModalProps) {
    const router = useRouter();
    const { status } = useSession();
    const prevStatus = useRef(status);

    useEffect(() => {
        if (prevStatus.current !== 'authenticated' && status === 'authenticated') {
            toast.success('You are now logged in!');
            onClose();
        }
        prevStatus.current = status;
    }, [status, onClose]);

    return (
        <Modal title="Sign in to continue" isOpen={isOpen} onCancel={onClose} classname="w-xs">
            <SignInButton callbackUrl={callbackUrl || router.asPath} classname="w-full mt-3" />
        </Modal>
    );
}
